import React from 'react';
import OrderCard from '../../../components/AdvanceMessagingComponent/OrderList/OrderCard';
import ProductList from '../../../components/AdvanceMessagingComponent/ProductList/ProductList';
import { INonLoggedInMessageData, ISendMessage } from '../../../hooks/chatbot/useCBChatMessage';
import { IMessage } from '../../../interfaces/component-interfaces';
import { IOrderData, IProductSelectData } from '../../../interfaces/order-tracking-flow-interfaces';
import { util } from '../../../utils/miaw/common';

export const handleOrderSelect = (data: ISendMessage, timestamp?: number): { userMessage: IMessage; query: string } => {
  const orderData = data.messageData as IOrderData;
  const message: IMessage = {
    id: util.generateUUID(),
    messageContent: (
      <OrderCard
        orderDate={orderData.orderDate}
        orderId={orderData.orderId}
        orderItems={orderData.orderItems}
        orderNumber={orderData.orderNumber}
        displayPrice={orderData.displayPrice}
        sender="user"
      />
    ),
    type: 'user',
    timestamp: timestamp || new Date().getTime(),
    isMessageRead: false,
    showFeedback: false,
    // senderDisplayName: '', // TODO
  };
  return { userMessage: message, query: `Order ID - ${orderData.orderId}` };
};

export const handleProductSelect = (data: ISendMessage, timestamp?: number): { userMessage: IMessage; query: string; selectedProductIds: string[] } => {
  const productData = data.messageData as IProductSelectData;
  const message: IMessage = {
    id: util.generateUUID(),
    messageContent: <ProductList items={productData.items} orderId={productData.orderId} sender="user" />,
    type: 'user',
    timestamp: timestamp || new Date().getTime(),
    isMessageRead: false,
    showFeedback: false,
    // senderDisplayName: 'User'
  };
  return {
    userMessage: message,
    query: `Order ID - ${productData.orderId} and Product ID - [${productData.items.map((i) => i.itemId).join(',')}]`,
    selectedProductIds: productData.items.map((i) => i.itemId),
  };
};

export const handleMessageWithDifferentQuery = (data: ISendMessage, timestamp?: number): { userMessage: IMessage; query: string } => {
  const message: IMessage = {
    id: util.generateUUID(),
    messageContent: data.messageData?.messageText as string,
    type: 'user',
    timestamp: timestamp || new Date().getTime(),
    isMessageRead: false,
    showFeedback: false,
    // senderDisplayName: 'User'
  };
  return { userMessage: message, query: data.messageData?.query as string };
};

export const handleTextMessage = (data: ISendMessage, timestamp?: number): { userMessage: IMessage; query: string } => {
  const message: IMessage = {
    id: util.generateUUID(),
    messageContent: data.messageData as string,
    type: 'user',
    timestamp: timestamp || new Date().getTime(),
    isMessageRead: false,
    showFeedback: false,
    // senderDisplayName: 'User'
  };
  return { userMessage: message, query: data.messageData as string };
};

export const handleNonLoggedInOrderMessage = (data: ISendMessage, timestamp?: number): { userMessage: IMessage; query: string } => {
  const userMessageData: IMessage = {
    id: util.generateUUID(),
    messageContent: (data.messageData as INonLoggedInMessageData).messageText,
    type: 'user',
    timestamp: timestamp || new Date().getTime(),
    isMessageRead: false,
    showFeedback: false,
  };

  return { userMessage: userMessageData, query: (data.messageData as INonLoggedInMessageData).query };
};
